// extracted by mini-css-extract-plugin
export var orderSummary = "_pt-0";
export var showMoreLessButton = "_pt-1";